import { transformUserObject } from 'utils/DataTransform/utils/user';
import { CustomerInfo } from './constants/informationText';
import { getItemOrDefaultToValue } from './details';

export const ContactFormFields = {
  customerId: {
    label: 'Customer ID',
    field: 'employeeId',
    type: 'text',
    required: false,
    size: 'full',
    placeholder: "Enter contact's id. e.g. CUST-0001",
  },
  firstName: {
    field: 'firstName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: "Enter contact's first name",
  },
  lastName: {
    field: 'lastName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: "Enter contact's last name",
  },
  phone: options => ({
    field: 'phone',
    type: 'phone',
    size: 'half',
    required: true,
    secondaryOptions: options,
    placeholder: 'Enter phone number',
  }),
  email: {
    field: 'email',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: "Enter contact's email",
  },
  languages: options => ({
    field: 'languages',
    type: 'multiselect',
    options,
  }),
  notes: { field: 'notes', type: 'textArea' },
};

export const getContactFieldConfig = ({
  panelHeader = 'New Contact',
  hidden,
  customConfig,
  countryOptions = [],
  languageOptions = [],
}) => {
  const {
    customerId,
    firstName,
    lastName,
    phone,
    email,
    languages,
    notes,
  } = ContactFormFields;
  return {
    field: 'client',
    type: 'sub-panel',
    panelHeader,
    hidden,
    subFields: customConfig
      ? customConfig
      : [
          customerId,
          firstName,
          lastName,
          phone(countryOptions),
          email,
          languages(languageOptions),
          notes,
        ],
  };
};

//use this generic form field object to create contact  subpanel
export const getBusinessClientContactFormFields = (
  addContact,
  countries,
  languages,
) => {
  return {
    field: 'client',
    type: 'sub-panel',
    panelHeader: 'New Contact',
    hidden: addContact,
    subFields: [
      {
        label: 'Customer ID',
        field: 'employeeId',
        type: 'text',
        required: false,
        size: 'full',
        // hidden: addContact,
        placeholder: "Enter contact's id. e.g. CUST-0001",
        info: CustomerInfo.customerId,
      },
      {
        field: 'firstName',
        type: 'text',
        required: true,
        size: 'half',
        hidden: addContact,
        placeholder: "Enter contact's first name",
      },
      {
        field: 'lastName',
        type: 'text',
        required: true,
        size: 'half',
        hidden: addContact,
        placeholder: "Enter contact's last name",
      },
      {
        field: 'phone',
        type: 'phone',
        size: 'half',
        required: true,
        secondaryOptions: countries,
        hidden: addContact,
        placeholder: 'Enter phone number',
      },
      {
        field: 'email',
        type: 'text',
        required: true,
        size: 'half',
        hidden: addContact,
        placeholder: "Enter contact's email",
        info: CustomerInfo.email,
      },
      {
        field: 'languages',
        type: 'multiselect',
        options: languages,
        hidden: addContact,
        info: CustomerInfo.languages,
      },
      { field: 'notes', type: 'textArea', maxLength: 250, hidden: addContact },
    ],
  };
};
//use this function to crate and transform data wherever contact is getting created
export const getContactData = (values, generalInfo, roles) => {
  const ids = values?.departments &&
    values?.departments.length > 0 && {
      departmentIds: getItemOrDefaultToValue(
        values,
        'departments',
        undefined,
      )?.map(m => m.id),
    };
  return transformUserObject({
    ...values,
    employeeId: values.employeeId,
    image: values.subPanelImage,
    phone: values.phone,
    country: values.country,
    firstName: values.firstName,
    lastName: values.lastName,
    role: roles.CLIENT.id,
    email: values.email,
    reliability: 5,
    languages: values.languages ? values.languages : ['EN'],
    notes: values.notes,
    regionId: generalInfo.regionId,
    securityCompanyId: generalInfo.securityCompanyId,
    securityCompanyName: generalInfo.securityCompanyName,
    ...(ids && { departmentIds: ids.departmentIds }),
  });
};
